import { FOOTER_LINKS_SEED_KEY, LIST_BUCKET, type FooterCityLinks } from '@todo/core/list-queries';
import { getPrefetched } from '@todo/core/static-prefetch';

// The last seed read, for client-side navigations: after one, the new page
// finds no baked <script> of its own to read (the in-memory prefetch cache is
// build-time only), but the list can't change without a rebuild.
let lastLinks: FooterCityLinks | undefined;

/**
 * Which cities have each kind of exported per-city page, as baked by the site
 * footer into every page (site-footer.web.tsx). Undefined only where nothing
 * was exported: `expo start` and native, where every route resolves.
 */
export function readFooterLinks(): FooterCityLinks | undefined {
  const baked = getPrefetched<FooterCityLinks>(LIST_BUCKET, FOOTER_LINKS_SEED_KEY);
  if (baked) lastLinks = baked;
  return baked ?? lastLinks;
}
